import React from 'react';

import styles from './Spinner.module.css';

export type SpinnerSize = 'sm' | 'md' | 'lg';

export interface SpinnerProps {
  size?: SpinnerSize;
  color?: string;
  className?: string;
}

export function Spinner({
  size = 'md',
  color = 'currentColor',
  className,
}: SpinnerProps) {
  return (
    <svg
      className={[styles.spinner, styles[size], className].filter(Boolean).join(' ')}
      viewBox="0 0 50 50"
      aria-hidden
    >
      <circle
        className={styles.circle}
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke={color}
        strokeWidth="4"
      />
    </svg>
  );
}
